module.exports = __webpack_public_path__ + "static/media/puzzleClue1.ae65e2f9.png";